import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';
import axios from "axios";

Vue.use(Vuex);

const vuexLocalStorage = new VuexPersist({
  key: 'vuex', // The key to store the state on in the storage provider.
  storage: window.localStorage, // or window.sessionStorage or localForage
  reducer: state => ({
    course: state.course,
    lesson: state.lesson,
    module: state.module,
    user_type: state.user_type,
    user: state.user,
    topic: state.topic
  })
})

const getDefaultState = () => {
  return {
    user: {},
    user_type: null,
    filename: null,
    course: null,
    userTypes: [
      {
        name: "Diretor",
        value: 0
      },
      {
        name: "Aluno",
        value: 1
      }, 
      {
        name: "Professor",
        value: 2
      }
    ],
    lesson: {},
    module: {},
    quiz: {}
  }
}

export const store = new Vuex.Store({
  plugins: [vuexLocalStorage.plugin],
  state: {
    quizList: [],
    user: {},
    productEdit: {},
    user_type: null,
    filename: null,
    course: null,
    userTypes: [
      {
        name: "Diretor",
        value: 0
      },
      {
        name: "Aluno",
        value: 1
      }, {
        name: "Professor",
        value: 2
      }
    ],
    lesson: {},
    module: {},
    quiz: {},
    questions: [],
    quizExecuted: [],
    dailySalesData: [],
    monthSalesData: [],
    productsSalesData: [],
    paymentRateData: [],
    topic: {},
    userEdit: {}
  },
  actions: {
    loadPaymentRate({ commit }) {
      const path = this._vm.$global.endpoint + "/analytics/getpaymentrate";
      axios
        .get(path)
        .then(res => {

          commit('change_payment_rate', res.data)
        })
        .catch(error => {
        });
    },
    loadProductSales({ commit }) {
      const path = this._vm.$global.endpoint + "/analytics/getpaymentdata";
      axios
        .post(path, {
          allProducts: true
        })
        .then(res => {

          commit('change_product_sales', res.data)
        })
        .catch(error => {
        });
    },
    loadMonthSales({ commit }) {
      const path = this._vm.$global.endpoint + "/analytics/getmonthlypaymentdata";
      axios
        .get(path)
        .then(res => {

          commit('change_month_sales', res.data)
        })
        .catch(error => {
        });
    },
    loadQuizList({ commit }, courseId) {

      const path = this._vm.$global.endpoint + "/quiz/getall";
      axios
        .post(path, {
          courseId: courseId,
          moduleId: moduleId
        })
        .then(res => {

          commit('change_quizlist', res.data)
        })
        .catch(error => {
        });
    },
    loadQuizList({ commit }, courseId) {

      const path = this._vm.$global.endpoint + "/quiz/getall";
      axios
        .post(path, {
          courseId: courseId
        })
        .then(res => {

          commit('change_quizlist', res.data)
        })
        .catch(error => {
        });
    },
    loadQuiz({ commit }, quizId) {
      console.log("entrou no loadQuiz", quizId);
      commit('reset_quiz');
      commit('reset_quiz_questions');
      const path = this._vm.$global.endpoint + "/quiz/get";
      axios
        .post(path, {
          quizId: quizId
        })
        .then(res => {

          commit('change_quiz', res.data.quiz);
          commit('change_quiz_questions', res.data.questions);
        })
        .catch(error => {
        });

    }
  },
  mutations: {
    reset_state(state) {
      Object.assign(state, getDefaultState())
    },
    change_filename(state, filename) {
      state.filename = filename
    },
    change_lesson(state, lesson) {
      state.lesson = lesson
    },
    change_module(state, module) {
      state.module = module
    },
    change_course(state, course) {
      state.course = course
    },
    change_user_type(state, user_type) {
      state.user_type = user_type
    },
    change_product_edit(state, productEdit) {
      state.productEdit = productEdit
    },
    change_user(state, user) {
      state.user = user
    },
    change_quizlist(state, quizList) {
      state.quizList = quizList
    },
    reset_quiz(state) {
      state.quiz = {}
    },
    reset_quiz_questions(state) {
      state.questions = []
    },
    change_quiz(state, quiz) {
      state.quiz = quiz
    },
    change_quiz_questions(state, questions) {
      state.questions = questions
    },
    change_product_sales(state, productSales) {
      state.productsSalesData = productSales
    },
    change_month_sales(state, monthlySales) {
      state.monthSalesData = monthlySales
    },
    change_payment_rate(state, paymentRate) {
      state.paymentRateData = paymentRate
    },
    change_topic(state, topic) {
      state.topic = topic
    },
    change_user_edit(state, userEdit) {
      state.userEdit = userEdit
    }
  },
  getters: {
    lesson: state => {
      return state.lesson
    },
    module: state => {
      return state.module
    },
    userTypes: state => {
      return state.userTypes
    },
    course: state => {
      return state.course
    },
    filename: state => {
      return state.filename
    },
    user_type: state => {
      return state.user_type
    },
    productEdit: state => {
      return state.productEdit
    },
    user: state => {
      return state.user
    },
    quiz: state => {
      return state.quiz
    },
    topic: state => {
      return state.topic
    },
    userEdit: state => {
      return state.userEdit
    }
  }
})